module.exports = __webpack_public_path__ + "static/media/range-connect.205d6006.svg";